import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=3376c2f2&scoped=true&"
import script from "./entity.vue?vue&type=script&lang=js&"
export * from "./entity.vue?vue&type=script&lang=js&"
import style0 from "./entity.vue?vue&type=style&index=0&id=3376c2f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3376c2f2",
  null
  
)

export default component.exports